// extracted by mini-css-extract-plugin
module.exports = {"camera-wrapper":"style_camera-wrapper__LSDXR","scanner-container":"style_scanner-container__inY6a"};